import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CREATE_ASSET_TYPE_SUCCESS,
  FETCH_ASSET_TYPE_SUCCESS,
  GET_ASSET_TYPE_SUCCESS,
  SAVE_ASSET_TYPE_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {
  fetchError,
  fetchFilter,
  fetchMasterFilter,
  fetchStart,
  fetchSubElementFilter,
  fetchSuccess,
  fetchSuperMasterFilter
} from "./Common";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_ASSET_TYPE_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_ASSET_TYPE_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_ASSET_TYPE_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_ASSET_TYPE_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {assetType} = store.getState();
      const {query} = assetType;
      const response = await axios.get(`/asset-type?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {assetType} = store.getState();
      const {query} = assetType;
      const response = await axios.get(`/asset-type/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload, redirect = true, module, subMaster = false, superMaster = false, pvModule = false) => {
  // console.log(payload, subMaster, superMaster);
  return async (dispatch) => {

    dispatch(fetchStart());
    try {
      let formData = new FormData();
      formData.append('name', payload.name);
      formData.append('description', payload.description);
      formData.append('isBowser', payload.isBowser || false);
      if(payload.files && payload.files.file) {
        formData.append('files', payload.files.file);
      }

      // Object.keys(payload).forEach(key => {
      //   if ( key === 'files') {
      //     return
      //   }
      //   formData.append(key, payload[key]);
      // });
      const response = await axios.post(`/asset-type`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      // console.log(response);
      // const response = await axios.post(`/asset-type`, payload);
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({data: response.data}));
      }

      if(!redirect) {
        if(pvModule)
          dispatch(fetchMasterFilter(module));
        else if(subMaster) {
          dispatch(fetchSubElementFilter(module));
        } else {
          if(superMaster) {
            dispatch(fetchSuperMasterFilter(module));
          } else {
            dispatch(fetchFilter(module));
          }
        }
      } else {
        history.push('/asset-type');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      let formData = new FormData();
      formData.append('name', payload.name);
      formData.append('description', payload.description);
      formData.append('isBowser', payload.isBowser);
      formData.append('assetClassification', payload.assetClassification);
      if(payload.files && payload.files.file) {
        formData.append('files', payload.files.file);
      }

      // await axios.put(`/asset-type/${id}`, payload);

      const response = await axios.put(`/asset-type/${id}`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else if (response && response.data && response.data.warningMessage) {
        message.warning(response.data.warningMessage, 5);
      }
      dispatch(fetchSuccess());
      history.push('/asset-type');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/asset-type/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.delete(`/common/asset-type/${id}`);
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
